<div *ngIf="toggleHide" class="additional-info-overlay"></div>
<main class="information-container">
    <div>
        <div *ngIf="isLocation()">
            <div class="information-text">
                <span class="image">
                    <img src="../../../../assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,2150,12,12))"
                        style="width:20px;height:20px" type="image/svg+xml">
                </span>
                <span class="label" (click)="getLocationData(configData.groupLevelAction);$event.stopPropagation();" >{{additionalInfo.label}}</span>
            </div>
            <div class="information-content" *ngIf="toggleHide">        
                <div class="close-icon">
                    <span (click)="toggleHide=false;$event.stopPropagation();">
                        <img src="../../../../assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,30,24,24))"
                            style="width:20px;height:20px" type="image/svg+xml">
                    </span>
                </div>
                <div  class="business-content" *ngIf="additionalInfo.component === 'LOCATION_DATA_V2'">
                    <app-location-data-v2 [locationData]="additionalInfo" [configData] ="configData"></app-location-data-v2>
                </div>        
            </div>
        </div>
        <div *ngIf="!isLocation()">
            <div class="message-information-text" *ngIf="isAction()" [ngClass]="{'setMargin': Data.orderExpedite === false}">
                <span class="image">
                    <img src="../../../../assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,2150,12,12))"
                        style="width:14px;height:14px" type="image/svg+xml">
                </span>
                <span class="message-label" (click)="getMessageData(configData.groupLevelAction)" >Action <br/>Needed</span>
            </div>
            <div class="info-text" *ngIf="!isAction()"  [ngClass]="{'setMargin': Data.orderExpedite === false}">
                <span class="image">
                    <img src="../../../../assets/images/alpha-icons/icons-blue-information.svg#svgView(viewBox(0,0,24,24))"
                        style="width:14px;height:14px" type="image/svg+xml">
                </span>
                <span class="info-label" (click)="getMessageData(configData.groupLevelAction)" >Info</span>
            </div>
            <div class="message-information-content" *ngIf="orderMessageHide"> 
                <div class="close-icon">
                    <span (click)="orderMessageHide=false">
                        <img src="../../../../assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,30,24,24))"
                            style="width:14px;height:14px" type="image/svg+xml">
                    </span>
                </div>
                <div *ngIf="isAction()">
                    <app-order-data-message [orderType]="true" [orderData]="additionalInfo" [configData] ="configData"></app-order-data-message>
                </div>
                <div *ngIf="!isAction()">
                    <app-order-data-message [orderType]="false" [orderData]="additionalInfo" [configData] ="configData"></app-order-data-message>
                </div>
            </div>
        </div>
    </div>   
</main>